import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxCompanyMachine/selectPage',
    method: 'GET',
    params: {
      ...params
    }
  })
}

// 导出主材成本统计
export function download (params) {
  return axios({
    url: '/sxCompanyMachine/download',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}
